import styled from 'styled-components';

import IconHelpOutlineSvg from '../../../assets/icons/icon-help-outline.svg?react';
import { AppLanguageSelector, BaseButton } from '../../../shared/ui';

type LoginHeaderActionsProps = {
  showHelpNotificationBadge?: boolean;
};

const HeaderActionsRow = styled.div.attrs({
  'data-ui': 'auth-login-header-actions',
})`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.scale.px(10)};

  & > [data-ui='shared-app-language-selector'] {
    margin-top: ${({ theme }) => theme.scale.px(7)};
  }
`;

const HelpAction = styled(BaseButton)`
  position: relative;
  width: ${({ theme }) => theme.scale.px(39)};
  height: ${({ theme }) => theme.scale.px(39)};
  cursor: default;
`;

const HelpIcon = styled(IconHelpOutlineSvg).attrs({
  'aria-hidden': true,
  focusable: 'false',
})`
  width: 100%;
  height: 100%;
  display: block;
  --help-icon-bg: ${({ theme }) => theme.colors.support.infoSubtle};
  --help-icon-fg: ${({ theme }) => theme.colors.text.primary};
`;

const HelpNotificationBadge = styled.span`
  position: absolute;
  top: ${({ theme }) => theme.scale.px(3)};
  right: ${({ theme }) => theme.scale.px(2)};
  width: ${({ theme }) => theme.scale.px(9)};
  height: ${({ theme }) => theme.scale.px(9)};
  box-sizing: border-box;
  border: ${({ theme }) => theme.scale.px(1)} solid
    ${({ theme }) => theme.colors.surface.base};
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.support.danger};
`;

export function LoginHeaderActions({
  showHelpNotificationBadge = false,
}: LoginHeaderActionsProps) {
  return (
    <HeaderActionsRow>
      <AppLanguageSelector />

      <HelpAction aria-hidden="true" tabIndex={-1} type="button">
        <HelpIcon />
        {showHelpNotificationBadge && <HelpNotificationBadge />}
      </HelpAction>
    </HeaderActionsRow>
  );
}
